import i18n from "@/plugins/i18n"

/**
 * Справочник ролей пользователей
 */
export const USERS_ROLES = {
    ETP_ADMIN: { code: 'etp_admin', name: i18n.global.t('Администратор ЭТП') },
    ORG_ADMIN: { code: 'org_admin', name: i18n.global.t('Администратор организатора') },
    ORGANIZER: { code: 'organizer', name: i18n.global.t('Организатор') },
    SUP_ADMIN: { code: 'supplier_admin', name: i18n.global.t('Администратор участника') },
    SUPPLIER:  { code: 'supplier', name: i18n.global.t('Участник') },
};

/**
 * Проверяет, является ли пользователь Администратором ЭТП.
 *
 * @param {string} roleCode Передаваемый код роли пользователя.
 * @returns {boolean} Возвращает true, если код роли - 'etp_admin', иначе false.
 */
export function isETPAdmin(roleCode: string): boolean {
    return USERS_ROLES.ETP_ADMIN.code === roleCode;
}

/**
 * Проверяет, является ли пользователь Администратором организатора.
 *
 * @param {string} roleCode Передаваемый код роли пользователя.
 * @returns {boolean} Возвращает true, если код роли - 'org_admin', иначе false.
 */
export function isORGAdmin(roleCode: string): boolean {
    return USERS_ROLES.ORG_ADMIN.code === roleCode;
}

/**
 * Проверяет, является ли пользователь Администратором участника.
 *
 * @param {string} roleCode Передаваемый код роли пользователя.
 * @returns {boolean} Возвращает true, если код роли - 'supplier_admin', иначе false.
 */
export function isSUPAdmin(roleCode: string): boolean {
    return USERS_ROLES.SUP_ADMIN.code === roleCode;
}